import { Inject, Injectable, Optional } from '@angular/core';
import { FEATURE_CONFIG } from './feature-toggles.config';
import { isBoolean } from './toggle-point/toggle-point-function';

/**
 * Interface of the configuration object required for the toggle router to
 * save the experimental features IDs.
 */
export interface FeatureConfig {
  [name: string]: boolean;
}

/**
 * @description
 * Service that stores the toggle router configuration, returns if a feature is
 * enabled or not and can add new settings.
 */
@Injectable({
  providedIn: 'root'
})
export class ToggleRouterService {
  private readonly featureConfig: FeatureConfig;

  constructor(@Optional() @Inject(FEATURE_CONFIG) config: FeatureConfig) {
    this.featureConfig = config || {};
  }

  /**
   * Add feature id and set isEnabled flag.
   *
   * @param featureName Feature ID.
   * @param isEnabled Flag that determines if is enabled.
   */
  setFeature(featureName: string, isEnabled: boolean = true): void {
    this.featureConfig[featureName] = isEnabled;
  }

  /**
   * Returns the feature state flag or false if the feature doesn't exist.
   *
   * @param featureName Feature ID.
   */
  isFeatureEnabled(featureName: string | boolean): boolean {
    if (isBoolean(featureName)) {
      return featureName as boolean;
    } else {
      return this.featureConfig[featureName as string] ? this.featureConfig[featureName as string] : false;
    }
  }
}
